import { render, staticRenderFns } from "./classificationTest.vue?vue&type=template&id=1191cc67&scoped=true&"
import script from "./classificationTest.vue?vue&type=script&lang=js&"
export * from "./classificationTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1191cc67",
  null
  
)

export default component.exports